// Replicates the Cloover calculator PMT formula (reverse-engineered from cloover.co/project_calculator).
// PMT(rate, nper, principal) where principal = totalPrice * (1 + clooverFee).
// Rates updated 2026-05-15 with Cloover Fee checkbox enabled.
export const calculateFinancingTable = (totalPrice: number) => {
  const clooverFee = 0.05;
  const tiers = [
    { term: 5, interestRate: 0.070649 },
    { term: 10, interestRate: 0.063238 },
    { term: 15, interestRate: 0.069133 },
    { term: 20, interestRate: 0.067874 },
  ];

  return tiers.map(({ term, interestRate }) => {
    const principal = totalPrice * (1 + clooverFee);
    const monthlyRate = interestRate / 12;
    const nper = term * 12;
    const pvif = Math.pow(1 + monthlyRate, nper);
    const monthlyPayment = (monthlyRate / (pvif - 1)) * (principal * pvif);

    return {
      term,
      interestRate,
      monthlyPaymentIncludingFees: Math.round(monthlyPayment * 100) / 100,
    };
  });
}